import ProfilesByResourceType from "../../dictionaries/ProfilesByResourceType";

const addProfileValuesToNewResource = (resourceType, profileName, setNewResourceState, combinedEvidenceMap) => {
    let meta;
    let section;
    let content;
    let profileUrl = "";
    let citedArtifactClassificationToAdd;
    let typeValue;
    let categoryToAdd;
    let useContextToAdd;
    let membershipValue;
    let actualValue;
    let definitionValue;
    let handlingValue;
    let combinationMethodValue;
    let characteristic;
    let codeValue;
    let synthesisTypeValue;
    let additionalProfiles;
    if (profileName) {
        const profileDictionary = ProfilesByResourceType[resourceType];
        if (profileDictionary) {
            for (const key in profileDictionary) {
                if (key === profileName) {
                    profileUrl = profileDictionary[key].url;
                    if (profileDictionary[key].citedArtifactClassificationToAdd) {
                        citedArtifactClassificationToAdd = profileDictionary[key].citedArtifactClassificationToAdd;
                    }
                    if (profileDictionary[key].typeValue) {
                        typeValue = profileDictionary[key].typeValue;
                    }
                    if (profileDictionary[key].synthesisTypeValue) {
                        synthesisTypeValue = profileDictionary[key].synthesisTypeValue;
                    }
                    if (profileDictionary[key].categoryToAdd) {
                        categoryToAdd = profileDictionary[key].categoryToAdd;
                    }
                    if (profileDictionary[key].useContextToAdd) {
                        useContextToAdd = profileDictionary[key].useContextToAdd;
                    }
                    if (profileDictionary[key].membershipValue) {
                        membershipValue = profileDictionary[key].membershipValue;
                    }
                    if (profileDictionary[key].actualValue === true || profileDictionary[key].actualValue === false) {
                        actualValue = profileDictionary[key].actualValue;
                    }
                    if (profileDictionary[key].definitionValue) {
                        definitionValue = profileDictionary[key].definitionValue;
                    }
                    if (profileDictionary[key].handlingValue) {
                        handlingValue = profileDictionary[key].handlingValue;
                    }
                    if (profileDictionary[key].combinationMethodValue) {
                        combinationMethodValue = profileDictionary[key].combinationMethodValue;
                    }
                    if (profileDictionary[key].codeValue) {
                        codeValue = profileDictionary[key].codeValue;
                    }
                    if (profileDictionary[key].sectionStarter) {
                        section = profileDictionary[key].sectionStarter;
                    }
                    if (profileDictionary[key].contentStarter) {
                        content = profileDictionary[key].contentStarter;
                    }
                    if (profileDictionary[key].characteristicStarter) {
                        characteristic = profileDictionary[key].characteristicStarter;
                    }
                    if (profileDictionary[key].additionalProfiles) {
                        additionalProfiles = profileDictionary[key].additionalProfiles;
                    }
                }
            }
            if (profileUrl) {
                meta = { "profile": [profileUrl] };
                if (additionalProfiles) {
                    meta.profile = meta.profile.concat(additionalProfiles);
                }
                if (profileName === "AbsenceOfExposureDefinition" && combinedEvidenceMap?.synthesisInterventionDescriptionReference) {
                    if (characteristic?.[0]?.valueReference) {
                        characteristic[0].valueReference = combinedEvidenceMap.synthesisInterventionDescriptionReference;
                    }
                }
                setNewResourceState(prevState => {
                    return {
                        ...prevState,
                        'resourceType': resourceType,
                        'profileSelected': profileName,
                        'meta': meta,
                        'citedArtifactClassificationToAdd': citedArtifactClassificationToAdd,
                        'section': section,
                        'content': content,
                        'characteristic': characteristic,
                        'typeValue': typeValue,
                        'categoryToAdd': categoryToAdd,
                        'useContextToAdd': useContextToAdd,
                        'membershipValue': membershipValue,
                        'actualValue': actualValue,
                        'definitionValue': definitionValue,
                        'handlingValue': handlingValue,
                        'combinationMethodValue': combinationMethodValue,
                        'codeValue': codeValue,
                        'synthesisTypeValue': synthesisTypeValue
                    }
                });
            }
        }
    } else if (profileName === "") {
        setNewResourceState(prevState => {
            return {
                ...prevState,
                'resourceType': resourceType,
                'profileSelected': "",
                'meta': undefined,
                'citedArtifactClassificationToAdd': undefined,
                'section': undefined,
                'content': undefined,
                'characteristic': undefined,
                'typeValue': undefined,
                'categoryToAdd': undefined,
                'useContextToAdd': undefined,
                'membershipValue': undefined,
                'actualValue': undefined,
                'definitionValue': undefined,
                'handlingValue': undefined,
                'combinationMethodValue': undefined,
                'codeValue': undefined,
                'synthesisTypeValue': undefined
            }
        });
    }
};

export default addProfileValuesToNewResource;